import {
  Target, Search, Handshake, PieChart, Users, ClipboardList, ShieldCheck,
  BarChart3, Cog, Globe, GraduationCap, FileCheck, PiggyBank, Clock, Brain,
  CircleDollarSign, Workflow,
  TrendingUp, Factory, Building2, Truck, Ship, Shirt, FlaskConical, Boxes,
  PenTool, Lightbulb, Award, Hexagon, Linkedin, Instagram
} from "lucide-react";

export const NAV_LINKS = [
  { label: "Inicio", path: "/", id: "inicio" },
  { label: "Nosotros", path: "/nosotros", id: "nosotros" },
  { label: "Servicios", path: "/servicios", id: "servicios" },
  { label: "Metodología", path: "/metodologia", id: "metodologia" },
  { label: "Industrias", path: "/industrias", id: "industrias" },
  { label: "Divisiones", path: "/divisiones", id: "divisiones" },
  { label: "Talento", path: "/talento", id: "talento" },
];

export const FOOTER_NAV = [
  { label: "Inicio", path: "/", id: "inicio" },
  { label: "Nosotros", path: "/nosotros", id: "nosotros" },
  { label: "Servicios", path: "/servicios", id: "servicios" },
  { label: "Metodología", path: "/metodologia", id: "metodologia" },
  { label: "Industrias", path: "/industrias", id: "industrias" },
  { label: "Divisiones", path: "/divisiones", id: "divisiones" },
  { label: "Contacto", path: "/contacto", id: "contacto" },
];

export const CONTACT = {
  founder: "Valeria Longinos",
  role: "Founder & Managing Director",
  phone: "+52 228 104 5877",
  phoneHref: "+522281045877",
  email: "valeria.longinos@brikpp.com",
  website: "www.brikpp.com",
  location: "Querétaro, México",
};

export const SERVICES = [
  { icon: Target, title: "Estrategia de Compras", desc: "Estrategia, category management y planes de generación de valor." },
  { icon: Search, title: "Sourcing Estratégico", desc: "Procesos RFQ / RFP, análisis de mercado y benchmarking." },
  { icon: Handshake, title: "Negociación", desc: "Estrategias de negociación para optimizar precios, condiciones y términos comerciales." },
  { icon: PieChart, title: "Análisis de Costos", desc: "TCO, estructuras de costo, precios y oportunidades de ahorro." },
  { icon: Users, title: "Desarrollo de Proveedores", desc: "Evaluación, homologación y desarrollo de capacidades de proveedores." },
  { icon: ClipboardList, title: "Gestión de Proveedores", desc: "Supplier Performance Management, indicadores y mejora del desempeño." },
  { icon: ShieldCheck, title: "Gestión de Riesgos", desc: "Identificación, evaluación y mitigación de riesgos de suministro." },
  { icon: BarChart3, title: "Inteligencia de Compras", desc: "Datos, tendencias e inteligencia de mercado para mejores decisiones." },
  { icon: Cog, title: "Procurement as a Service", desc: "Operación parcial o integral de la función de Compras." },
  { icon: Globe, title: "Compras Internacionales", desc: "Sourcing global, negociación y acompañamiento en procesos internacionales." },
  { icon: GraduationCap, title: "Capacitación", desc: "Formación y desarrollo de equipos y capacidades de Compras." },
  { icon: FileCheck, title: "Auditoría de Compras", desc: "Diagnóstico de procesos, políticas, controles y cumplimiento." },
];

export const VALUE_DIMENSIONS = [
  { icon: PiggyBank, title: "Financiera", desc: "Ahorros, mejores condiciones y optimización del costo total." },
  { icon: Users, title: "Proveedores", desc: "Mayor competencia, desarrollo de alternativas y relaciones sólidas." },
  { icon: Clock, title: "Procesos", desc: "Procesos claros, trazables y con indicadores." },
  { icon: ShieldCheck, title: "Riesgos", desc: "Menor exposición, continuidad y cumplimiento." },
  { icon: Target, title: "Estrategia", desc: "Mejores decisiones e información que fortalecen la competitividad del negocio." },
];

export const METHODOLOGY = [
  { icon: Search, title: "Diagnosticar", desc: "Entendemos tu situación actual, necesidades y madurez de Compras." },
  { icon: PenTool, title: "Diseñar", desc: "Definimos la estrategia, solución y plan de trabajo a la medida." },
  { icon: Cog, title: "Implementar", desc: "Convertimos la estrategia en procesos, herramientas y acciones concretas." },
  { icon: Users, title: "Operar", desc: "Operamos o fortalecemos tu función de Compras junto con tu equipo." },
  { icon: BarChart3, title: "Medir", desc: "Medimos resultados, indicadores e impacto generado." },
  { icon: TrendingUp, title: "Mejorar", desc: "Identificamos nuevas oportunidades para maximizar el valor." },
];

export const ECOSYSTEM = [
  { name: "BRIK Procurement", tagline: "Procurement as a Service", desc: "Operamos o reforzamos la función de Compras de tu empresa.", detailTitle: "Tu departamento externo de Compras.", detail: "Operamos parcial o integralmente la función de Compras de tu empresa, desde la gestión de requerimientos y cotizaciones hasta la negociación, seguimiento y gestión de proveedores." },
  { name: "BRIK Advisory", tagline: "Procurement Transformation", desc: "Diseñamos y profesionalizamos tu departamento de Compras.", detailTitle: "Transformamos la forma de comprar.", detail: "Diseñamos y fortalecemos estrategias, estructuras, procesos, políticas e indicadores para construir una función de Compras más profesional, eficiente y estratégica." },
  { name: "BRIK Global", tagline: "Global Sourcing & Supplier Management", desc: "Conectamos tu empresa con proveedores y oportunidades internacionales.", detailTitle: "Conectamos tu negocio con nuevas oportunidades.", detail: "Apoyamos procesos de sourcing internacional, búsqueda y desarrollo de proveedores, negociación y seguimiento comercial, aprovechando nuestra experiencia y red de aliados." },
  { name: "BRIK Intelligence", tagline: "Data that strengthens negotiation", desc: "Convertimos información de compras y mercado en decisiones estratégicas.", detailTitle: "Datos que se convierten en mejores decisiones.", detail: "Transformamos información de compras, costos, proveedores y mercado en análisis que permiten identificar oportunidades, negociar mejor y tomar decisiones con mayor claridad." },
  { name: "BRIK Academy", tagline: "Build Better Buyers", desc: "Capacitamos y desarrollamos el talento detrás de Procurement.", detailTitle: "Desarrollamos el talento detrás de Compras.", detail: "Diseñamos programas de capacitación, talleres y formación especializada para fortalecer las habilidades técnicas, comerciales y estratégicas de los equipos de Compras." },
  { name: "BRIK Network", tagline: "Better connections. Better opportunities.", desc: "Red de proveedores, especialistas y aliados estratégicos.", detailTitle: "Conectamos capacidades, proveedores y oportunidades.", detail: "Construimos una red de proveedores, especialistas y aliados que amplía las capacidades de BRIK y facilita conexiones de valor para nuestros clientes." },
  { name: "BRIK Audit", tagline: "Procurement Audit & Compliance", desc: "Evaluamos, diagnosticamos y fortalecemos la función de Compras.", detailTitle: "Evaluamos para saber qué fortalecer.", detail: "Diagnosticamos la función de Compras a través de la revisión de procesos, políticas, controles, proveedores e indicadores para identificar riesgos, brechas y oportunidades de mejora." },
];

export const INDUSTRIES = [
  { icon: Factory, title: "Metal Mecánica", desc: "Componentes, estructuras y manufactura.", image: "/brand/ref-steel.webp", alt: "Procurement en industria metalmecánica — bobinas de acero en planta" },
  { icon: Building2, title: "Construcción e Infraestructura", desc: "Proyectos, obra civil y equipamiento.", image: "/brand/ref-towers.webp", alt: "Procurement en construcción e infraestructura — arquitectura corporativa" },
  { icon: Truck, title: "Logística y Transporte", desc: "Operaciones, flotas y cadena de suministro.", image: "/brand/ref-warehouse.webp", alt: "Procurement en logística y transporte — centro de distribución" },
  { icon: Ship, title: "Comercio Exterior", desc: "Importación, exportación y cumplimiento.", image: "/brand/ref-port.webp", alt: "Procurement en comercio exterior — puerto y buque de carga" },
  { icon: Shirt, title: "Textil", desc: "Materias primas, insumos y producción.", image: "/brand/ind-textil.webp", alt: "Procurement en industria textil — rollos de tela en planta de producción" },
  { icon: FlaskConical, title: "Químicos", desc: "Materias primas, insumos y especialidades.", image: "/brand/ind-quimicos.webp", alt: "Procurement en industria química — planta de procesos con tanques y tuberías" },
  { icon: Boxes, title: "Industria en General", desc: "Soluciones adaptadas a cada sector.", image: "/brand/ind-general.webp", alt: "Procurement industrial — componentes de manufactura en planta" },
];

export const PILLARS = [
  { icon: Target, title: "Estrategia", desc: "Entendemos tu negocio para definir prioridades y diseñar soluciones a la medida." },
  { icon: Cog, title: "Ejecución", desc: "Implementamos y operamos soluciones para convertir la estrategia en resultados." },
  { icon: BarChart3, title: "Inteligencia", desc: "Transformamos datos e información de mercado en mejores decisiones de compra." },
  { icon: TrendingUp, title: "Valor", desc: "Generamos impacto medible en costos, proveedores, procesos y gestión de riesgos." },
];

export const VALUES = [
  { icon: ShieldCheck, title: "Integridad" },
  { icon: Target, title: "Enfoque en resultados" },
  { icon: Users, title: "Colaboración" },
  { icon: Lightbulb, title: "Innovación práctica" },
  { icon: Award, title: "Excelencia" },
];

export const SOCIALS = [
  { id: "linkedin", label: "LinkedIn de BRIK Procurement Partners", url: "https://www.linkedin.com/company/brik-procurement-partners/", icon: Linkedin },
  { id: "instagram", label: "Instagram de BRIK Procurement Partners", url: "https://www.instagram.com/brik.pp", icon: Instagram },
];

export const RESULTS_BAR = [
  { icon: CircleDollarSign, label: "Ahorros sostenibles" },
  { icon: Handshake, label: "Proveedores competitivos" },
  { icon: Workflow, label: "Procesos eficientes" },
  { icon: Brain, label: "Decisiones inteligentes" },
];

export const MARQUEE_ITEMS = [
  "Better Buying. Better Business.",
  "Estrategia",
  "Ejecución",
  "Inteligencia",
  "Valor",
  "People. Procurement. Progress.",
];

export const HexIcon = Hexagon;
